"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPlayFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4.943 2.3c.592-.364 1.242-.397 1.951-.1l12.026 8.013c.72.447 1.08 1.043 1.08 1.79 0 .747-.36 1.343-1.08 1.79L6.894 21.8c-.706.297-1.356.262-1.95-.105-.595-.368-.91-.93-.944-1.685V3.99c.038-.76.352-1.324.943-1.69z' }))); };
exports.default = SvgPlayFilled;
//# sourceMappingURL=PlayFilled.js.map